import Chart from "chart.js";

export const displayTextInChart = {
    id: "displayTextInChart",
    afterDatasetsDraw(chart) {
        if (chart.options.plugins && chart.options.plugins.barTextPlugin === false) {
            return;
        }
        
        const ctx = chart.ctx;
        chart.data.datasets.forEach((dataset, i) => {
            const meta = chart.getDatasetMeta(i);
            if (!meta.hidden) {
                meta.data.forEach((element, index) => {
                    const value = dataset.data[index];
                    if (value === 0) return;

                    ctx.fillStyle = "white";
                    const fontSize = 16;
                    const fontStyle = "normal";
                    const fontFamily = "Montserrat";
                    ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
                    const dataString = value.toString();
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle";

                    const model = element._model;
                    const centerY = (model.y + model.base) / 2;
                    ctx.fillText(dataString, model.x, centerY);
                });
            }
        });
    }
};
